import {z} from 'zod';
import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {clinchEnums} from '@cl/shared';
import {CLEnumKeys, CLEnumType} from 'common/src/modules/enums/enums.types';
import {baseCardSchema} from './baseSchemas';
import {LandingPageSource} from 'common/src/modules/campaigns/campaigns.enums';

const {loadedEnumsSubject} = clinchEnums;

// Creative Card Schema
export const creativeCardSchema = baseCardSchema.extend({
  type: z.literal(NodeType.CREATIVE),
  creativeId: z
    .number()
    .describe(
      'The ID of the creative to connect to the card, if not provided, the user will be asked to select a creative from a list',
    ),
  landingPageSource: z
    .nativeEnum(LandingPageSource)
    .describe(
      `match the user request to one of the following options: ${loadedEnumsSubject.data[
        CLEnumType.CampaignPage
      ]?.[CLEnumKeys.CampaignPage.LandingPageSource]?.enumsForSelector
        .map((enumMapper) => `${enumMapper.name}: ${enumMapper.value}`)
        .join(', ')}`,
    ),
  isFallback: z
    .boolean()
    .describe(
      'Whether the creative card is a fallback creative, empty creativeId is NOT a fallback creative',
    ),
  features: z.array(z.string()).describe('Supported features shown by this creative.'),
});
